module.exports = __webpack_public_path__ + "static/media/do.87a61ac6.webp";